module.exports = __webpack_public_path__ + "static/media/gdpr-3438451_1920.f0247fa8.jpg";